export default __webpack_public_path__ + "static/media/upload-blue.8bb20253.svg";